import React from "react";

export default function CancelButton({
  children,
  onClick,
  disabled = false,
  className = "",
  type = "button",
   bgColor = "bg-white", // default background color
  textColor = "text-colorButton",   // default text color
}) {
  return (
    <button
      type={type}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      className={`flex items-center justify-center ${bgColor} border border-gray-500 ${textColor} px-4 py-1 rounded transition text-sm  hover:opacity-90 active:scale-95 ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
    >
      {children}
    </button>
  );
}
